export default (() => {
  let lastScrollTop
  const body = document.querySelector("body");
  const megaMenus = document.querySelectorAll('[data-menu]')

  const fixedPoint = 10;
  let ticking = false;

  const scrollFunction = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (window.scrollY >= fixedPoint) {
          body.classList.add("scrolled");

        } else {
          body.classList.remove("scrolled");
        }
        ticking = false;
      });

      ticking = true;
    }
  };

  const closeMenusOnScroll = () => {
    const scrollTop = document.documentElement.scrollTop
    const scrollThreshold = 10 // Add a 10px threshold to buffer for tiny movements

    if (scrollTop > lastScrollTop + scrollThreshold || scrollTop < lastScrollTop - scrollThreshold) {
      megaMenus.forEach(menu => {
        if (menu.menu && typeof menu.menu.close === 'function') {
          menu.menu.close()
        }
      })
    }

    lastScrollTop = scrollTop
  }
  // For every scroll event, if you aren't already waiting,
  // wait until you're going to redraw next then update the classes
  scrollFunction();
  closeMenusOnScroll()
  window.addEventListener("scroll", scrollFunction);
  window.addEventListener("scroll", closeMenusOnScroll);
})();

// @Megan